/** Steps for the adaptive login (email → SSO redirect or password). */
export const LOGIN_STEP = {
  EMAIL: 'email',
  PASSWORD: 'password',
}

// Restrict domain to hostname-safe chars; TLD letters-only so trailing # etc. are invalid.
const LOGIN_EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const getEmailContinueValidationMessage = (raw, t) => {
  const trimmed = raw?.trim()
  if (!trimmed) {
    return t?.['Email is required']
  }
  if (raw !== trimmed) {
    return t?.['Please add an email with the following format example@example.com']
  }
  if (!LOGIN_EMAIL_PATTERN.test(trimmed)) {
    return t?.['Please add an email with the following format example@example.com']
  }
  return null
}

export const getPasswordValidationMessage = (raw, t) => {
  if (!raw) {
    return t?.['Password is required']
  }
  return null
}
